(() => {
  if (window.__ddIndependentMenuControlsV3) return;
  window.__ddIndependentMenuControlsV3 = true;
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const CLOSE_DELAY = 1200;
  let closeTimer = null;
  const getSummary = (menu) => menu?.querySelector(':scope > summary');
  const closeMenus = (except = null) => {
    document.querySelectorAll('.dd-header-nav .dd-mega-menu[open]').forEach((menu) => {
      if (menu !== except) {
        menu.removeAttribute('open');
        const summary = getSummary(menu);
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    });
  };
  const openMenu = (menu) => {
    if (!menu || !desktopQuery.matches) return;
    window.clearTimeout(closeTimer);
    closeMenus(menu);
    menu.setAttribute('open', '');
    const summary = getSummary(menu);
    if (summary) summary.setAttribute('aria-expanded', 'true');
  };
  const scheduleClose = (menu) => {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      if (!menu.matches(':hover') && !menu.contains(document.activeElement)) {
        menu.removeAttribute('open');
        const summary = getSummary(menu);
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    }, CLOSE_DELAY);
  };
  document.querySelectorAll('.dd-header-nav .dd-mega-menu').forEach((menu) => {
    menu.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse' || event.pointerType === 'pen') openMenu(menu);
    });
    menu.addEventListener('pointerleave', () => {
      if (desktopQuery.matches) scheduleClose(menu);
    });
    menu.addEventListener('focusin', () => openMenu(menu));
    menu.addEventListener('focusout', () => scheduleClose(menu));
  });
  document.addEventListener('click', (event) => {
    const mobileLink = event.target.closest('#menu-drawer .dd-mobile-nav-link');
    if (mobileLink) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = mobileLink.getAttribute('href');
      if (url && url !== '#') window.location.href = url;
      return;
    }
    const summary = event.target.closest('.dd-header-nav summary[data-dd-nav-link]');
    if (summary) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = summary.getAttribute('data-dd-nav-link');
      if (url) window.location.assign(url);
      return;
    }
    if (!event.target.closest('.dd-header-nav')) closeMenus();
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenus();
  });
  desktopQuery.addEventListener?.('change', () => {
    window.clearTimeout(closeTimer);
    if (!desktopQuery.matches) closeMenus();
  });
})();